(function () {
  function init() {
    const product = document.querySelector('.product-box');
    if (!product || !product.querySelector('#bm-adapt-details, #bm-tw-details, #bm-sf-details, #bm-brand-details, #bm-accessory-details, #bm-base-details, .bm-mattress-comfort')) return;
    const gallery = product.querySelector('[data-product-gallery]');
    const container = gallery && gallery.querySelector('[data-carousel-container]');
    if (!container || gallery.dataset.bmActiveHeight) return;
    gallery.dataset.bmActiveHeight = 'true';
    gallery.classList.add('bm-active-image-gallery');
    let swiper;
    let frame = 0;
    let attempts = 0;
    let timer;
    let lastWidth = container.clientWidth;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function refresh() {
      frame = 0;
      if (!swiper || swiper.destroyed) return;
      swiper.params.autoHeight = true;
      swiper.updateAutoHeight(reducedMotion.matches ? 0 : 180);
    }
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(refresh);
    }
    function connect() {
      if (swiper) return;
      const instance = container.swiper;
      if (!instance || instance.destroyed) return;
      swiper = instance;
      window.clearInterval(timer);
      swiper.params.autoHeight = true;
      if (swiper.originalParams) swiper.originalParams.autoHeight = true;
      container.classList.add('swiper-container-autoheight');
      ['slideChange', 'slideChangeTransitionStart', 'slideChangeTransitionEnd', 'lazyImageReady', 'imagesReady', 'resize', 'update'].forEach(function (event) {
        swiper.on(event, schedule);
      });
      swiper.update();
      schedule();
    }
    gallery.addEventListener('load', function () { connect(); schedule(); }, true);
    window.addEventListener('load', function () { connect(); schedule(); }, { once: true });
    if ('ResizeObserver' in window) {
      const widthObserver = new ResizeObserver(function () {
        const width = container.clientWidth;
        if (width !== lastWidth) {
          lastWidth = width;
          connect();
          if (swiper && !swiper.destroyed) swiper.update();
          schedule();
        }
      });
      widthObserver.observe(container);
      const imageObserver = new ResizeObserver(schedule);
      gallery.querySelectorAll('.swiper-slide img').forEach(function (image) { imageObserver.observe(image); });
    }
    connect();
    if (!swiper) timer = window.setInterval(function () {
      connect();
      attempts += 1;
      if (swiper || attempts >= 300 || !container.isConnected) window.clearInterval(timer);
    }, 100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
